import React, { useEffect, useState } from 'react';
import { __ } from '@wordpress/i18n';
import { useStateValue } from '../../../../store/store';
import sendPostMessage from '../../../../components/site-preview/utils'
import { Spacer, P } from '../../../../ui/style'
import { FontSelector } from '../../../../components/index';
import NextStepButton from '../../../../components/util/next-step-button/next-step-button';
import { getFontName } from '../../../../components/font-selector/font-selector';

const fontImages = {
	'rufina': `${starterTemplates.imageDir}font-rufina-sourcesanspro.svg`,
	'sriracha': `${starterTemplates.imageDir}font-sriracha-opensans.svg`,
	'dmseriftext': `${starterTemplates.imageDir}font-dmseriftext-lato.svg`,
	'librefranklin': `${starterTemplates.imageDir}font-librefranklin-poppins.svg`,
	'montserrat': `${starterTemplates.imageDir}font-montserrat-lato.svg`,
	'playfairdisplay': `${starterTemplates.imageDir}font-playfairdisplay-opensans.svg`,
};

const SiteTypographyControls = (props) => {
	const [{ websiteTypography, templateResponse }, dispatch] = useStateValue();
	const { onNextClick, customizeStep } = props;
	let [state, setSelfState] = useState({
		fonts: [
			{
				"preview": fontImages['rufina'],
				"body-font-family": "'Source Sans Pro', sans-serif",
				"body-font-variant": "400",
				"body-font-weight": "400",
				"font-size-body": {
					"desktop": 17,
					"tablet": "",
					"mobile": "",
					"desktop-unit": "px",
					"tablet-unit": "px",
					"mobile-unit": "px"
				},
				"body-line-height": 1.7,
				"headings-font-family": "'Rufina', serif",
				"headings-font-weight": "700",
				"headings-line-height": "",
				"headings-font-variant": "700",
			},
			{
				"preview": fontImages['sriracha'],
				"body-font-family": "'Open Sans', sans-serif",
				"body-font-variant": "400",
				"body-font-weight": "400",
				"font-size-body": {
					"desktop": 16,
					"tablet": "",
					"mobile": "",
					"desktop-unit": "px",
					"tablet-unit": "px",
					"mobile-unit": "px"
				},
				"body-line-height": 1.7,
				"headings-font-family": "'Sriracha', handwriting",
				"headings-font-weight": "400",
				"headings-line-height": "",
				"headings-font-variant": "400",
			},
			{
				"preview": fontImages['dmseriftext'],
				"body-font-family": "'Lato', sans-serif",
				"body-font-variant": "400",
				"body-font-weight": "400",
				"font-size-body": {
					"desktop": 16,
					"tablet": "",
					"mobile": "",
					"desktop-unit": "px",
					"tablet-unit": "px",
					"mobile-unit": "px"
				},
				"body-line-height": 1.8,
				"headings-font-family": "'DM Serif Text', serif",
				"headings-font-weight": "400",
				"headings-line-height": "",
				"headings-font-variant": "400",
			},
			{
				"preview": fontImages['librefranklin'],
				"body-font-family": "'Poppins', sans-serif",
				"body-font-variant": "",
				"body-font-weight": "400",
				"font-size-body": {
					"desktop": 15,
					"tablet": "",
					"mobile": "",
					"desktop-unit": "px",
					"tablet-unit": "px",
					"mobile-unit": "px"
				},
				"body-line-height": 1.8,
				"headings-font-family": "'Libre Franklin', sans-serif",
				"headings-font-weight": "500",
				"headings-line-height": "",
				"headings-font-variant": "500",
			},
			{
				"preview": fontImages['montserrat'],
				"body-font-family": "'Lato', sans-serif",
				"body-font-variant": "",
				"body-font-weight": "400",
				"font-size-body": {
					"desktop": 17,
					"tablet": "",
					"mobile": "",
					"desktop-unit": "px",
					"tablet-unit": "px",
					"mobile-unit": "px"
				},
				"body-line-height": 1.7,
				"headings-font-family": "'Montserrat', sans-serif",
				"headings-font-weight": "700",
				"headings-line-height": "",
				"headings-font-variant": "",
			},
			{
				"preview": fontImages['playfairdisplay'],
				"body-font-family": "'Open Sans', sans-serif",
				"body-font-variant": "400",
				"body-font-weight": "400",
				"font-size-body": {
					"desktop": 15,
					"tablet": "",
					"mobile": "",
					"desktop-unit": "px",
					"tablet-unit": "px",
					"mobile-unit": "px"
				},
				"body-line-height": "",
				"headings-font-family": "'Playfair Display', serif",
				"headings-font-weight": "600",
				"headings-line-height": "",
				"headings-font-variant": "600",
			}
		],
		selectedTypography: 0,
	});

	useEffect(() => {
		let fonts = [];
		let customizer_data = templateResponse['astra-site-customizer-data'] || '';
		console.log('customizer_data', customizer_data);
		if (customizer_data) {
			let customizer_settings = customizer_data['astra-settings'] || [];

			let headingFontFamily = customizer_settings['headings-font-family'];
			let fontSlug = getFontName(headingFontFamily).replace(' ', '').toLowerCase();

			fonts.push({
				'default': true,
				'preview': fontImages[fontSlug],
				'body-font-family': customizer_settings['body-font-family'],
				'body-font-variant': customizer_settings['body-font-variant'],
				'body-font-weight': customizer_settings['body-font-weight'],
				'font-size-body': customizer_settings['font-size-body'],
				'body-line-height': customizer_settings['body-line-height'],
				'headings-font-family': headingFontFamily,
				'headings-font-weight': customizer_settings['headings-font-weight'],
				'headings-line-height': customizer_settings['headings-line-height'],
				'headings-font-variant': customizer_settings['headings-font-variant'],
			});
		}
		fonts = fonts.concat(state.fonts);
		setSelfState({ ...state, fonts: fonts, selectedTypography: fonts[websiteTypography] });

		// Send current selected typography.
		document.getElementById('astra-starter-templates-preview').onload = function () {
			sendPostMessage({
				param: "siteTypography",
				data: state.selectedTypography,
			});
		};
	}, []);

	useEffect(() => {
		sendPostMessage({
			param: "siteTypography",
			data: state.selectedTypography,
		});
	}, [websiteTypography]);

	const saveTypography = () => {
		const data = new FormData();
		data.append('action', 'astra_sites_set_site_data');
		data.append('param', 'site-typography');
		data.append('typography', JSON.stringify(selectedTypography));
		data.append('security', starterTemplates.nonce);

		fetch(ajaxurl, {
			method: 'post',
			body: data
		});
	}


	return (
		<>
			<FontSelector
				selected={websiteTypography}
				options={state.fonts}
				onSelect={(selectedFont) => {
					dispatch({
						type: 'set',
						websiteTypography: selectedFont,
					})
				}}
			/>

			<P>{__('You can also change the colors later from the Customiser.', 'astra-sites')}</P>

			<Spacer />

			<NextStepButton customizeStep={customizeStep} after onClick={(event) => {
				saveTypography();
				onNextClick();
			}}>{__('Proceed', 'astra-sites')}</NextStepButton>
		</>
	)
}

export default SiteTypographyControls;
